import { z } from 'zod';
import { uuid } from './comunes.js';
/**
 * Evidencia documental de una orden o requerimiento.
 * Las categorías salen de las cláusulas de LOG-FT-02.
 */
export const CATEGORIAS_ADJUNTO = [
    'COTIZACION', 'FACTURA', 'GUIA_REMISION', 'CERTIFICADO_CALIDAD',
    'FICHA_TECNICA', 'CARTA_GARANTIA', 'ORDEN_FIRMADA', 'OTRO',
];
export const ETIQUETA_CATEGORIA = {
    COTIZACION: 'Cotización',
    FACTURA: 'Factura',
    GUIA_REMISION: 'Guía de remisión',
    CERTIFICADO_CALIDAD: 'Certificado de calidad',
    FICHA_TECNICA: 'Ficha técnica',
    CARTA_GARANTIA: 'Carta de garantía',
    ORDEN_FIRMADA: 'Orden firmada',
    OTRO: 'Otro',
};
/** 20 MB. El mismo límite lo impone un CHECK en la base. */
export const ADJUNTO_MAX_BYTES = 20 * 1024 * 1024;
/**
 * Tipos permitidos. Lista blanca a propósito: una lista negra siempre deja
 * pasar algo, y acá se guardan archivos que otras personas van a abrir.
 */
export const MIME_PERMITIDOS = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
];
export const EXTENSIONES_PERMITIDAS = '.pdf, .jpg, .png, .webp, .xlsx, .xls, .docx, .doc';
export const categoriaAdjunto = z.enum(CATEGORIAS_ADJUNTO);
export const adjunto = z.object({
    id: uuid,
    documentoId: uuid,
    nombreOriginal: z.string(),
    mimeType: z.string(),
    tamanoBytes: z.number().int(),
    categoria: categoriaAdjunto,
    checksumSha256: z.string(),
    creadoEn: z.iso.datetime(),
    subidoPor: z.string().nullable(),
});
export function tamanoLegible(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
//# sourceMappingURL=adjunto.js.map